export default __webpack_public_path__ + "static/media/Fence's Pants of the Dusk Rebellion.68c4600b.jpg";